/**
 * Форматирование данных публичного профиля.
 * Все строки — через i18n-ключи publicProfile.* (t передаётся из компонентов,
 * как в rushdropFormat.formatDrawLeft).
 */

/** Все времена приходят секундами назад — только отформатировать */
export function formatAgo(sec, t) {
  if (sec == null) return ''
  if (sec < 60) return t('publicProfile.ago.justNow', 'только что')
  if (sec < 3600) return t('publicProfile.ago.minutes', { count: Math.floor(sec / 60) })
  if (sec < 86400) return t('publicProfile.ago.hours', { count: Math.floor(sec / 3600) })
  if (sec < 30 * 86400) return t('publicProfile.ago.days', { count: Math.floor(sec / 86400) })
  return t('publicProfile.ago.months', { count: Math.floor(sec / (30 * 86400)) })
}

/** «57 дней» — для подписи «на проекте …» (плюрализация i18next по языку) */
export function formatOnProjectDays(sec, t) {
  const days = Math.max(1, Math.floor(sec / 86400))
  return t('publicProfile.onProjectDays', { count: days })
}

/** ISO 3166-1 alpha-2 (для картинки флага с flagpedia; эмодзи-флаги не рендерятся на Windows) */
export const isValidCountryCode = (code) => (
  typeof code === 'string' && /^[A-Za-z]{2}$/.test(code)
)

/** Режимы: last_bet.game, top_games[].game */
export const getGameLabel = (game, t) => {
  if (typeof game !== 'string' || !game) return t('games.title', 'Игры')
  if (game === 'mines') return t('mines.title')
  return t(`publicProfile.games.${game}`, { defaultValue: game })
}

/** Источники предметов: top_skins[].source */
export const getSourceLabel = (source, t) =>
  source === 'mines' ? t('mines.title') : t(`publicProfile.sources.${source}`, { defaultValue: source })
